const imageSource = {
  // mock
  car: "/assets/mock/car.jpg",
  carAndScooty: "/assets/mock/carAndScooty.png",
  carRide: "/assets/mock/carRide.png",
  nissan: "/assets/mock/nissan.png",
  rounded: "/assets/mock/rounded.png",
  circleIcon: "/assets/mock/circle-icon.png",
  facebook: "/assets/mock/Facebook.png",
  instagram: "/assets/mock/Instagram.png",
  x: "/assets/mock/x.png",
  key: "/assets/mock/key.jpg",
  leftArrow: "/assets/mock/left-icon.png",
  rightArrow: "/assets/mock/right-icon.png",
  jeep: "/assets/mock/jeep.png",
  checkImage: "/assets/mock/check-image.png",
  dot: "/assets/mock/three-dot.png",
  emailIcon: "/assets/mock/email.png",
  passwordIcon: "/assets/mock/password.png",
  userIcon: "/assets/mock/user-icon.png",
  vision1: "/assets/mock/visionimg1.jpg",
  vision2: "/assets/mock/visionimg2.png",
  vision3: "/assets/mock/visionimg3.jpg",
  homeBannerImage: "/assets/mock/home-page-banner.png",
  carSearchBar: "/assets/mock/car-search-bar.png",

  // images
  authSidebar: "/assets/images/auth-side-bar.png",
  calendar: "/assets/images/calender.png",
  carDekhoLogo: "/assets/images/carDekhoLogo.png",
  easlyName: "/assets/images/easly-name.png",
  electric: "/assets/images/electric.png",
  gps: "/assets/images/gps.png",
  crown: "/assets/images/crown.png",
  hatachback: "/assets/images/hatachback.png",
  homeCar: "/assets/images/home-car.png",
  homePageBackground: "/assets/images/home-page-background.png",
  icSecuritySafety: "/assets/images/ic-security-safety.png",
  logo: "/assets/images/logo.png",
  navBarLogo: "/assets/images/nav-bar-logo.png",
  redLogo: "/assets/images/red-logo.png",
  medalStar: "/assets/images/medal-star.png",
  messages2: "/assets/images/messages-2.png",
  scootyRide: "/assets/images/bike-with-blue-circle.png",
  miniVan: "/assets/images/minivan.png",
  pickUp: "/assets/images/pickup.png",
  powerSetring: "/assets/images/power-setreeng.png",
  pumpIcon: "/assets/images/pump-icon.png",
  refreshRightSquare: "/assets/images/refresh-right-square.png",
  sedan: "/assets/images/sedan.png",
  suv: "/assets/images/suv.png",
  upiImage: "/assets/images/upi-image.png",
  userProfileArrow: "/assets/images/user-profile-arrow.png",
  userTick: "/assets/images/user-tick.png",
  visa: "/assets/images/Visa.png",
  wallet: "/assets/images/wallet.png",
  weOffersBackground: "/assets/images/we-offers-backgraund.png",
  weOffers: "/assets/images/we-offers.png",
  productsListsNoDataFound: "/assets/images/products-lists-no-data-found.png",
  lamboUrus: "/assets/images/Lambo_urus.png",
  testimonial: "/assets/images/testimonial.jpg",
  black_fortuner: "/assets/images/black_fortuner.png",
  white_fortuner_black_roof: "/assets/images/white_fortuner_black_roof.png",
  white_fortuner: "/assets/images/white_fortuner.png",
  fortuner_and_bike: "/assets/images/fortuner_and_bike.png",
  bike: "/assets/mock/bike.png",
  loading: "/assets/images/loading.svg",
  self_driven:'/assets/images/self_driven.png'
};

export { imageSource };
